module.exports = __webpack_public_path__ + "28ccbff97fe53638456aa3210e5d8081.png";